import { ReactElement } from 'react'
import { Stack, Typography } from '@mui/material'
import { ChangeDecision } from './DecisionButtons'

/** What became of a file request: uploaded, or declined. */
const FileRequestDecision = ({ decision }: { decision: ChangeDecision }): ReactElement => (
  <Stack direction="row" mt={1} justifyContent="flex-end">
    <Typography
      variant="caption"
      color={decision === 'approved' ? 'success.main' : 'text.secondary'}
    >
      {decision === 'approved' ? 'Hochgeladen' : 'Ohne Datei fortgefahren'}
    </Typography>
  </Stack>
)

export default FileRequestDecision
